import React from 'react'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Resources() {
	return (
		<Container maxWidth='lg' style={{ padding: 10, marginBottom: 150, minHeight:700  }}>
		<Grid container justify='center' spacing={2}>
			<Grid item xs={12} sm={8} md={8} >
				<Paper style={{ padding: 20 }} >
					<Text variant='h5' gutterBottom>
						Resources
					</Text>
					<Text variant='caption' gutterBottom>
						<ul>
							<li>Blogs on fundraising techniques</li>
							<li>How To's</li>
							<li>Fundraising Ideas</li>
							<li>Promotion Ideas</li>
							<li>Tips and Tricks</li>
						</ul>
					</Text>
				</Paper>
			</Grid>
		</Grid>
		</Container>
	)
}
export default Resources
